import dynamic from "next/dynamic";
import Image from "next/image";
import { Marquee } from "@/components/magicui/marquee";
import FancyButton from "../ui/fancy-button";

const VideoPlayer = dynamic(() => import("@/components/shared/VideoPlayer"), { ssr: false });

const clipKeys = [
  "chatgpt-1",
  "chatgpt-2",
  "reddit-1",
  "reddit-2",
  "reddit-3",
  "split-1",
  "story-1",
  "text-1",
  "text-2",
  "text-3",
];

const CarouselSection = () => (
  <div className="select-none space-y-10 @container">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto flex flex-col items-center space-y-3 sm:text-center md:max-w-4xl lg:max-w-none">
        <p className="text-balance text-center text-[48px] font-semibold leading-[1.05] text-[#101828]">
          <span className="inline lg:hidden">Over</span> 2.5M clips have been{" "}
          <span className="text-[#335CFF]">made with Crayo</span>
        </p>
        <p className="text-pretty text-center text-[20px] tracking-[0.01em] text-[#525866] ">
          Crayo&apos;s AI tools help you catch trends and create content that goes viral.
        </p>
      </div>
    </div>
    <div className="flex w-full items-center justify-center">
      <Marquee className="xl:max-w-[1920px]">
        {clipKeys.map((clipKey) => (
          <div key={clipKey} className="max-w-[90%]">
            <VideoPlayer
              clipPath={`https://cdn-crayo.com/lp/public/landing/clips/${clipKey}.mp4`}
            />
          </div>
        ))}
      </Marquee>
    </div>
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-center gap-x-2">
        <p className="text-center text-lg/8 text-gray-600">Made with </p>
        <Image
          src="https://cdn-crayo.com/lp/public/crayoBlue.png"
          width={72}
          height={17}
          alt="CRAYO Logo"
          draggable={false}
        />
      </div>
      <div className="flex items-center justify-center">
        <FancyButton href="https://crayo.ai/dashboard" size="xl">
          Try Crayo Now
        </FancyButton>
      </div>
    </div>
  </div>
);

export default CarouselSection;
